// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: "light",
  themeDirection: "ltr",
  themeContrast: "default",
  themeLanguage: "fr",
  themeLayout: "vertical",
  themeColorPresets: "default",
  themeStretch: false,
};
